import {
  InputGroup,
  Input,
  InputRightElement,
  forwardRef,
  InputProps,
  Divider,
  Icon,
  IconButton,
} from '@chakra-ui/react';
import { Fragment, ReactNode } from 'react';

import SearchIcon from '@/assets/icons/ic-search.svg';

interface ISearchInputProps extends InputProps {
  actionSlot?: ReactNode;
  onSearch?: () => void;
}

export const SearchInput = forwardRef<ISearchInputProps, 'input'>((props, ref) => {
  const { placeholder, value, defaultValue, onChange, actionSlot, onSearch, 'aria-label': ariaLabel, ...rest } = props;

  return (
    <InputGroup {...rest}>
      <Input
        ref={ref}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        borderRadius="full"
        _placeholder={{ color: 'gray.800' }}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        pr={actionSlot ? 20 : 10}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSearch?.();
          rest.onKeyDown?.(e);
        }}
      />
      <InputRightElement pl={0} pr={2} minW="max-content" display="flex">
        {actionSlot && (
          <Fragment>
            {actionSlot}
            <Divider orientation="vertical" h={6} mx={2} />
          </Fragment>
        )}
        {onSearch ? (
          <IconButton
            variant="unstyled"
            aria-label="Search"
            icon={<Icon as={SearchIcon} color="black" boxSize="24px" />}
            minW="unset"
            h="auto"
            display="flex"
            onClick={onSearch}
          />
        ) : (
          <Icon as={SearchIcon} color="black" boxSize="24px" />
        )}
      </InputRightElement>
    </InputGroup>
  );
});
